import angular from 'angular';
import mailTemplates from './mailTemplates';
import mailTemplatesSelection from './mailTemplatesSelection/mailTemplatesSelection';
import mergeFieldSelection from '../mergeFieldsSelection';

export default angular
  .module('components.contactMailTemplates', [mergeFieldSelection])
  .component('mailTemplates', mailTemplates)
  .component('mailTemplatesSelection', mailTemplatesSelection).name;
